export default {
  props: {
    wrap: {
      type: String,
    },
    gutter: {
      type: String,
    },
    removeVerticalGutter: {
      type: Boolean,
    },
    verticalAlign: {
      type: String,
    },
  },
};
